import { PartnerApplication } from '~domains/partner-application/widgets/partner-application';

export const PartnerApplicationCreatePage = () => {
  return <PartnerApplication />;
};
